import i18n from './config/config';

export type { LocaleType } from './config/constants';

export { DEFAULT_LANGUAGE, LOCALES, HOST_LOCALE_MAPPING, CONTENT_LANGUAGE } from './config/constants';

export { TRANSLATION_RESOURCES } from './config/resources';

export {
  translate,
  initResources,
  setLanguage,
  isTranslationAvailable,
  getLanguageCodeByHost,
  setLanguageByHost,
  getResources,
} from './utils';

export default i18n;
